import React, { useEffect, useState } from 'react';
import { Avatar } from 'antd';
import Header from "./Header";
import Sidebar from "./Sidebar";


import { fetchProfileFromApi } from "../../shared/actions/ProfileActions"
import { getProxyListApi  } from '../../shared/actions/ProxyActions';
import { connect, useDispatch, useSelector } from "react-redux";
import { View, Text, Switch, TouchableOpacity, ActivityIndicator } from 'react-native-web';
import HomeCard from './HomeCard';
import { fetchfAppointmentsFromApi } from '../../shared/actions/FutureAppointActions';
import { fetchAllergyFromApi } from '../../shared/actions/AllergiesActions';
import { fetchAdministeredImmunefromApi } from '../../shared/actions/AdministeredImmuneActions';
import { fetchTreactOfChoiceFromApi } from '../../shared/actions/TreatmentOfChoneMedicationAction';
import { fetchPractisefromAPI } from "../../shared/actions/PractiseAction";
import { fetchLongTermFromApi } from '../../shared/actions/DiagnosisActions';
import { FlatList } from 'react-native';
import { capitalize, GetAppointmentDate, GetMonthName, GetYear } from '../../shared/core/datehelper';
import TreatmentHandler from './TreatmentHandler';
import { fetchDueImmunefromApi } from '../../shared/actions/DueImmuneActions';
import { Link } from 'react-router-dom';
import getUserId from '../../shared/core/GetToken';
import Settings from '../../shared/config/Settings';
import $ from "jquery";
import { getInitials, getColorForInintials } from '../../shared/core/utils';
import { appServices } from '../../shared/redux/actions/appServices';
import getUserInfo from '../../shared/core/GetTokenized';
import { Content } from 'antd/lib/layout/layout';

const loadjs = require('loadjs');
const MainContainer = (props) => {
    const { children } = props;
    const [frontState, setFrontState] = React.useState(false);
    const openMenu = () => {
        var element = document.getElementById("myphonemenu");

        setFrontState(frontState => !frontState);
        setFrontState((state) => {
            state ? element.classList.add("sidebar-collpased") : element.classList.remove("sidebar-collpased");
            return state;
        });
    }
    return (
        <div>
            <Header onClick={() => openMenu()} />
            <div id="myphonemenu" className="page-body">
               
                         <Sidebar />

             <Content>
              <div className="justify-content-end p-2 w-100 h-100 overflow-auto">
                {children}
              </div>

            </Content>

                {/* <div className="page-content-wrapper">
                    
                     <footer className="footer">

                    </footer> 
                </div> */}

            </div>

        </div>
    );
}


export default MainContainer